import axios from '@/libs/axios'
import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'
import {
  checkHiddenAttr,
  designateOptions,
  designateValue,
  hasValue,
  transformField
} from '@/helpers/formConditions'

const defaultState = () => {
  return {
    userRole: null,
    roles: [],
    authSettings: null,
    registrationForm: {},
    preparedFields: [],
    allConditions: [],
    hasFileField: false,
    hasSignatureField: false,
    isLoading: false,
    validTracker: false,
    serverMessage: '',
    errorMessage: '',
    validationErrors: [],
    returnPageRouteName: null,
    returnPageRouteParams: null,
    disabledInfoMessage: '',
    isSendButtonDisabled: false,
  }
}


export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getIsLoading: state => state.isLoading,
    getRoles: state => state.roles,
    getUserRole: state => state.userRole,
    getRegistrationForm: state => state.registrationForm,
    getHasFileField: state => state.hasFileField,
    getHasSignatureField: state => state.hasSignatureField,
    getPreparedFields: state => state.preparedFields,
    getAllConditions: state => state.allConditions,
    getValidTracker: state => state.validTracker,
    getServerMessage: state => state.serverMessage,
    getErrorMessage: state => state.errorMessage,
    getValidationErrors: state => state.validationErrors,
    getReturnPageRouteName: state => state.returnPageRouteName,
    getReturnPageRouteParams: state => state.returnPageRouteParams,
    getDisabledInfoMessage: state => state.disabledInfoMessage,
    getIsSendButtonDisabled: state => state.isSendButtonDisabled,
  },
  mutations: {
    SET_USER_ROLE: (state, data) => {
      state.userRole = data
    },
    SET_IS_LOADING: (state, data) => {
      state.isLoading = data
    },
    SET_RETURN_PAGE_ROUTE_NAME: (state, data) => {
      state.returnPageRouteName = data
    },
    SET_RETURN_PAGE_ROUTE_PARAMS: (state, data) => {
      state.returnPageRouteParams = data
    },
    SET_VALID_TRACKER: (state, data) => {
      state.validTracker = data
    },
    SET_SERVER_MESSAGE: (state, data) => {
      state.serverMessage = data
    },
    SET_VALIDATION_ERRORS: (state, data) => {
      state.validationErrors = data
    },
    SET_ERROR_MESSAGE: (state, data) => {
      state.errorMessage = data
    },
    SET_ROLES: (state, data) => {
      state.roles = data
    },
    SET_AUTH_SETTINGS: (state, data) => {
      state.authSettings = data
    },
    SET_REGISTRATION_FORM: (state, data) => {
      state.registrationForm = data
    },
    SET_FORMS_DATA: state => {
      let index = 0
      state.preparedFields = state.registrationForm.fields.map(field => {
        if (['avatar', 'file_upload'].includes(field.type)) state.hasFileField = true
        if (field.type === 'signature') state.hasSignatureField = true

        const ref = field.name + index
        index++

        return {
          id: field.id,
          ref: ref,
          value: designateValue(field.type, field.default, field.options),
          label: field.label,
          name: field.name,
          settings: field.settings,
          options: designateOptions(field.type, field.options),
          type: transformField(field.type),
          required: field.required,
          hidden: checkHiddenAttr(field.conditions.filter(item => item.action === 'Show')),
          use_prefill: field.use_prefill,
          attribute_field_name: field.attribute_field_name,
          password_repeat: null,
        }
      })

      state.allConditions =  state.registrationForm.conditions
    },
    CHECK_CONDITIONS: state => {
      state.allConditions.forEach(condition => {
        let isMatched
        for (let i = 0; i < condition.scoped_conditions.length; i++) {
          const scopeItems = condition.scoped_conditions[i];
          const scopeItemsResults = scopeItems.map(item => {
            const foundedField = state.preparedFields.find(field => field.id === item.field_id)
            return hasValue(item, foundedField.value)
          })
          isMatched = scopeItemsResults.every(i => i === true)
          if (isMatched || i == condition.scoped_conditions.length - 1) {

            if (condition.related_type === 'Field') {
              const field = state.preparedFields.find(field => field.id === condition.related_id)

              if (field) {
                field.hidden = condition.action === 'Show' ? !isMatched : isMatched
                if (!isMatched) {
                  field.value = designateValue(field.type, field.value, field.options)
                }
              }
            }

            if (condition.action === 'disable_submission') {
              state.disabledInfoMessage = null
              const forceDisablingSendButton = !!isMatched

              const infoMessage = condition.settings.find(s => s.key === 'info_message')
              if (isMatched && infoMessage.value) {
                state.disabledInfoMessage = infoMessage.value
              }

              state.isSendButtonDisabled = forceDisablingSendButton

              scopeItems
                .forEach(item => {
                  const field = state.preparedFields.find(field => field.id === item.field_id)

                  if (field) {
                    field.customInvalid = forceDisablingSendButton
                  }
                })
            }
            break
          }
        }
      })
    },
    UPDATE_RELATED_VALUE_FORM: (state, { updatedFieldId, value }) => {
      const updatedField = state.preparedFields.find(f => f.id === updatedFieldId)
      if (updatedField) {
        updatedField.value = value
      }
    },
  },
  actions: {
    prepareRoleOptions(ctx) {
      const allRoles = ['parent', 'student', 'staff']

      const availableRoles = allRoles.filter(role =>
        prepareProgramRegistrationInfo.methods.availableRegularRegistration(role, ctx.state.authSettings)
      )

      ctx.commit('SET_ROLES', availableRoles)
    },
    fetchSchoolRegistrationForm(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`school-registration-forms/${queryParams.role}`, {
            params: queryParams.query,
            headers: {
              WithoutSchoolFilter: true,
            }
          })
          .then(response => {
            ctx.commit('SET_REGISTRATION_FORM', response.data.data.form)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}